

















import { Component, Mixins } from 'vue-property-decorator'

// Mixins
import Contact from '@/mixins/Contact'
// Components
import Box from '@/components/common/Box.vue'

@Component({
  components: {
    Box
  }
})
export default class ContactUsModal extends Mixins(Contact) {
}
